export const euro = Intl.NumberFormat("es-ES", {
  style: "currency",
  currency: "EUR",
});



// WEBPACK FOOTER //
// ./src/utils/priceFormatter.jsx